import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";
import { useState } from "react";

import { ExportFormat, ReportTab } from "../types";

interface ExportDialogProps {
  open: boolean;
  reportTab: ReportTab;
  onClose: () => void;
  onExport: (format: ExportFormat) => void;
}

const ExportDialog = ({ open, reportTab, onClose, onExport }: ExportDialogProps) => {
  const [format, setFormat] = useState<ExportFormat>("csv");

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Export Report</DialogTitle>
      <DialogContent dividers>
        <TextField
          select
          fullWidth
          label="Format"
          value={format}
          onChange={(event) => setFormat(event.target.value as ExportFormat)}
        >
          <MenuItem value="csv">CSV</MenuItem>
          <MenuItem value="json">JSON</MenuItem>
        </TextField>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          onClick={() => {
            onExport(format);
            onClose();
          }}
        >
          Export {reportTab}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExportDialog;
